'use strict';

var loadScript = require('./load').loadScript;

var Logan = void 0;
var enable = false;

module.exports = {
    queue: [],
    ready: function ready() {
        var _this = this;

        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var LoganAPI = config.LoganAPI,
            pageUrl = config.pageUrl,
            project = config.project;


        enable = true;

        var doTask = function doTask() {
            Logan.log('[\u65B0\u9879\u76EE]: \u9879\u76EE-> ' + project + ' \u5BF9\u5E94\u7684\u9875\u9762-> ' + pageUrl + ' ');
            while (_this.queue.length) {
                var message = _this.queue.shift();
                Logan.log(message);
            }
        };

        if (LoganAPI) {
            Logan = LoganAPI;
            doTask();
        } else {
            loadScript('//www.dpfile.com/app/dp-logan-web/logan.min.3639c840b0b83d754a7b0034e7ece223.js', function () {
                Logan = window.Logan;
                doTask();
            });
        }
    },
    log: function log(message) {
        var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (!enable) return;

        var type = 'owl';
        if (opts.noType) {
            type = undefined;
        }
        if (Logan) {
            Logan.log(message, type);
        } else {
            this.queue.push(message);
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/owl/lib/util/logan.js
// module id = 75
// module chunks = 0